import { configureStore } from '@reduxjs/toolkit';
import orderSlice from './Slices/orderSlice';
import productSlice from './Slices/productSlice';
import gtmSlice from './Slices/gtmSlice';
import subscriptionReducer from './Slices/subscriptionSlice';

export const store = configureStore({
  reducer: {
    order: orderSlice,
    product: productSlice,
    gtm: gtmSlice,
    subscription: subscriptionReducer,
  }
});